const isLocalhost = require("../environment/isLocalhost");

/**
 * @param marketoForm {MarketoForm}
 * @return {Promise<void>}
 * @throws {Error} - Marketo failed to submit because of a validation error
 */
module.exports = async function submitMarketoForm(marketoForm) {
    return new Promise((resolve, reject) => {
        if (isLocalhost()) {
            alert("Form cannot be submitted to Marketo on localhost. Skipping submission!");

            setTimeout(() => {
                resolve();
            }, 2000);
        } else {
            marketoForm.onValidate(valid => {
                if (!valid) {
                    reject(new Error("Form invalid"));
                }
            });

            marketoForm.onSuccess(() => {
                resolve();
                return false; // Prevent page redirect
            });

            marketoForm.submit();
        }
    });
}
